export default __webpack_public_path__ + "static/media/3.cb1bca7c.JPG";